// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsborder{
    border-bottom: none !important;
  }

.h6, h6 {
  font-size: 1rem;
}

:host ::ng-deep .tab-content{
  padding: 1rem;
}

:host ::ng-deep .layout_space{
  padding: 0%;
}

:host ::ng-deep .nav.nav-tabs.nav-underline .nav-item a.nav-link {
  padding: 0.5rem 0rem;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhvcml6b250YWwtY3VzdG9taXplci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksOEJBQThCO0VBQ2hDOztBQUVGO0VBQ0UsZUFBZTtBQUNqQjs7QUFFQTtFQUNFLGFBQWE7QUFDZjs7QUFFQTtFQUNFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLG9CQUFvQjtBQUN0QiIsImZpbGUiOiJob3Jpem9udGFsLWN1c3RvbWl6ZXIuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi50YWJzYm9yZGVye1xuICAgIGJvcmRlci1ib3R0b206IG5vbmUgIWltcG9ydGFudDtcbiAgfVxuXG4uaDYsIGg2IHtcbiAgZm9udC1zaXplOiAxcmVtO1xufVxuXG46aG9zdCA6Om5nLWRlZXAgLnRhYi1jb250ZW50e1xuICBwYWRkaW5nOiAxcmVtO1xufVxuXG46aG9zdCA6Om5nLWRlZXAgLmxheW91dF9zcGFjZXtcbiAgcGFkZGluZzogMCU7XG59XG5cbjpob3N0IDo6bmctZGVlcCAubmF2Lm5hdi10YWJzLm5hdi11bmRlcmxpbmUgLm5hdi1pdGVtIGEubmF2LWxpbmsge1xuICBwYWRkaW5nOiAwLjVyZW0gMHJlbTtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/_layout/customizer/horizontal-customizer/horizontal-customizer.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;EAChC;;AAEF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA,oyBAAoyB","sourcesContent":[".tabsborder{\n    border-bottom: none !important;\n  }\n\n.h6, h6 {\n  font-size: 1rem;\n}\n\n:host ::ng-deep .tab-content{\n  padding: 1rem;\n}\n\n:host ::ng-deep .layout_space{\n  padding: 0%;\n}\n\n:host ::ng-deep .nav.nav-tabs.nav-underline .nav-item a.nav-link {\n  padding: 0.5rem 0rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
